import React from 'react';
import {Link} from 'react-router';
import { Collapse } from "@blueprintjs/core";
import {header} from "constants/table";
import DataTable from 'components/data-table';
import {RowItemLetterTable} from 'modules/home/dataTable';

class LettersTable extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state ={
      isOpen: true
    }
  }

  handleCollapse() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    return (
      <section className="wrap-collapse col-6 pb30 collapse-table">
        <div className="wrap-shadow">
          <h2 className={this.state.isOpen ? "collapse-title collapse-open" : "collapse-title collapse-close"}><Link onClick={this.handleCollapse.bind(this)}>{this.props.title}</Link></h2>
          <Collapse className="letter-collapse-wrap" isOpen={this.state.isOpen}>
            <div className="row">
              <DataTable
                dataList={this.props.data}
                header = {header.home.letterTable}
                hidePagination>
                <RowItemLetterTable type={this.props.type} onClickDetail={this.props.onClickDetail}/>
              </DataTable>
            </div>
          </Collapse>
        </div>
      </section>
    );
  }
}

export default LettersTable;



// WEBPACK FOOTER //
// ./src/components/modules/home/LettersTable.jsx